import { render, staticRenderFns } from "./order_return_detail.vue?vue&type=template&id=d6268f52&scoped=true"
import script from "./order_return_detail.vue?vue&type=script&lang=js"
export * from "./order_return_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6268f52",
  null
  
)

export default component.exports